/* eslint-disable */
// @ts-nocheck
/*
 * Scroll choreography for the concept sections (#concepts, #whatif, #native, #bad, #bidir, #versions) and the
 * hero ⇄ first-concept page turn. Ported from the "Nexus Figure Styles" design file.
 * initConcepts() wires everything up and returns a cleanup function (safe under React StrictMode).
 */
import { STEPS, BAA, coverSVG, replay, stepHTML } from '../../common/nexusArt';

export const PINS = [
  { sec: 'concepts', idx: [0], inline: true, lock: (s) => s.offsetTop - 62 },
  { sec: 'bad', idx: [3], inline: true, gate: true },
  { sec: 'bidir', idx: [5], inline: true, mobileLast: true },
];

/* markup for a pinned section, also used for the first render */
export const stageHTML = (idx, on = true) =>
  idx.map((i) => STEPS[i]).map((st, k) => `<div class="fig${on && k === 0 ? ' on' : ''}" data-k="${k}"><svg viewBox="${st.vb}" role="img">${st.svg()}</svg></div>`).join('');
export const swapHTML = (idx, on = true) => idx.map((i) => STEPS[i]).map((st, k) => {
  const h = stepHTML(st, k);
  return on && k === 0 ? h.replace('class="step"', 'class="step on"') : h;
}).join('');

export function initConcepts() {
  const ac = new AbortController();
  const opt = (o = {}) => Object.assign({ signal: ac.signal }, o);
  const on = (type, fn, o) => window.addEventListener(type, fn, opt(o));
  const timeouts = [];
  const later = (fn, ms) => { const t = setTimeout(fn, ms); timeouts.push(t); return t; };
  const observers = [];

  const pinState = {};
  let stepBusy = false;
  const lockY = (sec) => Math.round(sec.offsetTop + sec.offsetHeight / 2 - (innerHeight + 62) / 2);

  function buildRot() {
    PINS.forEach((pn) => {
      const sec = document.getElementById(pn.sec);
      const steps = pn.idx.map((i) => STEPS[i]);
      sec.querySelector('.stagewrap').innerHTML = stageHTML(pn.idx, false);
      sec.querySelector('.swap').innerHTML = swapHTML(pn.idx, false);
      const wsum = steps.reduce((a, s) => a + s.w, 0);
      sec.dataset.wsum = wsum;
      pinState[pn.sec] = { cur: -1, phase: -1, steps, wsum };
      renderPin(pn.sec, 0, true);
      // no wheel-stepping on narrow screens: show the finished state instead of the bare first step
      if (pn.mobileLast && innerWidth <= 900) renderPhase(pn.sec, steps[0].n - 1);
    });
    sizePins();
  }
  function sizePins() {
    PINS.forEach((pn) => {
      const sec = document.getElementById(pn.sec);
      const st = sec.querySelector('.sticky');
      if (innerWidth <= 900 || pn.inline) { sec.style.height = ''; return; }
      const H = st.offsetHeight;
      sec.style.setProperty('--h', H + 'px');
      sec.style.height = `calc(${H}px + 100vh * ${(+sec.dataset.wsum * 0.75).toFixed(2)})`;
    });
  }
  function renderPin(id, k, force) {
    const S = pinState[id]; const sec = document.getElementById(id); const st = S.steps[k];
    sec.querySelectorAll('.fig').forEach((el) => {
      const i = +el.dataset.k; el.classList.toggle('on', i === k); el.classList.toggle('out', i < k);
      if (i === k && (force || el.dataset.played !== '1')) { el.dataset.played = '1'; if (!S.steps[i].svgp) el.querySelector('svg').innerHTML = S.steps[i].svg(); }
    });
    sec.querySelectorAll('.step').forEach((el) => { const i = +el.dataset.i; el.classList.toggle('on', i === k); el.classList.toggle('out', i < k); });
    S.cur = k; S.phase = -1; if (st.svgp) renderPhase(id, 0);
  }
  function renderPhase(id, ph) {
    const S = pinState[id]; const st = S.steps[S.cur]; if (!st.svgp) return;
    ph = Math.min(st.n - 1, ph); if (ph === S.phase) return;
    const prev = S.phase; S.phase = ph;
    const sec = document.getElementById(id); const el = sec.querySelector(`.fig[data-k="${S.cur}"] svg`);
    if (el) {
      if (st.texts && ph <= 1 && prev >= 0 && prev <= 1 && el.dataset.morph === '1') {
        const px = ph >= 1;
        el.querySelectorAll('[data-px]').forEach((g) => { g.style.opacity = (g.dataset.px === '1') === px ? 1 : 0; });
      } else { el.innerHTML = st.svgp(ph); el.dataset.morph = st.texts ? '1' : ''; }
    }
    if (st.texts) { const t = st.texts[ph]; sec.querySelectorAll('.tx').forEach((x) => x.classList.toggle('on', +x.dataset.t === t)); }
    sec.querySelectorAll(`.step[data-i="${S.cur}"] .baw`).forEach((w) => w.classList.toggle('on', +w.dataset.w === BAA[ph]));
    if (ph === st.n - 1) S.done = true;
    sec.querySelectorAll('.stepprog button').forEach((b, i) => {
      b.classList.toggle('on', i < ph); b.disabled = !S.done;
      if (i === ph - 1) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
  }
  function onScroll() {
    if (innerWidth <= 900) return;
    PINS.forEach((pn) => {
      const S = pinState[pn.sec]; if (!S) return; const sec = document.getElementById(pn.sec);
      const r = sec.getBoundingClientRect(); if (r.top > innerHeight || r.bottom < 0) return; let p;
      if (pn.inline) {
        const S2 = pinState[pn.sec]; const ly = pn.lock ? pn.lock(sec) : lockY(sec);
        if (pn.lock) { if (!stepBusy && !conceptBusy && !S2.playing && scrollY > ly + 60 && S2.phase !== S2.steps[0].n - 1) renderPhase(pn.sec, S2.steps[0].n - 1); return; }
        if (!stepBusy) {
          if (scrollY < ly - 160 && S2.phase !== 0) renderPhase(pn.sec, 0);
          else if (scrollY > ly + 60 && S2.phase !== S2.steps[0].n - 1 && !(pn.gate && !S2.done)) renderPhase(pn.sec, S2.steps[0].n - 1);
        }
        return;
      } else {
        const stk = sec.querySelector('.sticky'); const top = parseFloat(getComputedStyle(stk).top) || 62;
        const total = sec.offsetHeight - stk.offsetHeight; p = Math.min(1, Math.max(0, (top - r.top) / (total * 0.92)));
      }
      let acc = 0, i = 0, local = 0;
      for (; i < S.steps.length; i++) { const f = S.steps[i].w / S.wsum; if (p < acc + f || i === S.steps.length - 1) { local = (p - acc) / f; break; } acc += f; }
      i = Math.min(S.steps.length - 1, i); local = Math.min(0.999, Math.max(0, local));
      if (i !== S.cur) renderPin(pn.sec, i);
      if (S.steps[i].svgp) renderPhase(pn.sec, Math.floor(local * S.steps[i].n));
    });
  }

  /* precise (trackpad / Magic Mouse) scrolling vs. a notched wheel. Chrome/Safari/Edge report wheelDeltaY ≈ -3·deltaY
     for precise scrolling but ±120 per notch (deltaY 4 on macOS, 100 on Windows); Firefox has no wheelDeltaY and sends
     a notched wheel in lines. A ratio band rather than equality keeps it working under page zoom. */
  const isTrackpad = (e) => {
    if (e.deltaMode !== 0) return false;
    if (e.wheelDeltaY && e.deltaY) { const r = -e.wheelDeltaY / e.deltaY; return r > 2 && r < 4.5; }
    return Math.abs(e.deltaY) < 50;
  };
  /* a lock waits for the wheel to go quiet, but on a trackpad a new swipe often starts while the last one's momentum
     is still running, so it never does. Momentum only decays; a new swipe makes |deltaY| climb again (as Lethargy.js
     does). Feed every wheel event; true = this event opens a new swipe. */
  const swipeWatch = () => {
    let at = 0, mags = [];
    return (e) => {
      const now = performance.now(), quiet = now - at > 220; at = now;
      if (quiet) mags = [];
      mags.push(Math.abs(e.deltaY)); if (mags.length > 8) mags.shift();
      if (quiet) return true;
      if (mags.length < 8 || !isTrackpad(e)) return false;
      const avg = (a) => a.reduce((t, x) => t + x, 0) / a.length, old = avg(mags.slice(0, 4)), cur = avg(mags.slice(4));
      if (cur > 6 && cur > old * 1.5) { mags = []; return true; }
      return false;
    };
  };

  const keyDir = (e) => {
    const k = e.key;
    return (k === 'ArrowDown' || k === 'PageDown' || (k === ' ' && !e.shiftKey)) ? 1 : (k === 'ArrowUp' || k === 'PageUp' || (k === ' ' && e.shiftKey)) ? -1 : 0;
  };

  /* ── Brush · Ask · Discover and Bidirectional Mapping: one wheel tick = one step while the section sits centred;
        neighbours stay on screen.
        gate (#bad): until the walk-through has been played to the end once, every wheel tick near the section steps it,
        wherever the pointer is, and a fast scroll that overshoots is pulled back. After that, only the chart column
        steps (replay); over the text the page scrolls normally.
        A wheel gesture that began outside the section only brings the page to it (parks on the current step); stepping
        takes a fresh gesture. Chrome lets a page cancel only the first wheel event of a gesture, so a swipe that started
        above keeps scrolling (momentum included) whatever preventDefault says — while parked or locked the position is
        held from the scroll event instead. ── */
  function wireStepper(id, gate = false) {
    const sec = () => document.getElementById(id);
    const n = () => pinState[id].steps[0].n, ph = () => Math.max(0, pinState[id].phase);
    const forced = () => gate && !pinState[id].done;
    const overChart = (e) => !!(e && e.target && e.target.closest && e.target.closest(`#${id} .stagecol`));
    /* true = stepped, 'park' = only brought to the lock point */
    const tryStep = (dir, e, arriving = false) => {
      if (innerWidth <= 900) return false; const s = sec(), ly = lockY(s), y = scrollY;
      if (gate && !forced() && !overChart(e)) return false;
      const reach = forced() ? innerHeight / 2 : 40; // first visit: also catch a swipe that already ran past the lock point
      const go = (d) => { scrollTo({ top: ly, behavior: 'instant' }); if (arriving) return 'park'; renderPhase(id, ph() + d); return true; };
      if (dir > 0 && ph() < n() - 1 && y >= ly - 160 && y <= ly + reach) return go(1);
      if (dir < 0 && ph() > 0 && y <= ly + 160 && y >= ly - 40) return go(-1);
      return false;
    };
    /* stay locked until the phase animation has played AND the current wheel gesture (incl. trackpad momentum) has
       gone quiet — otherwise the tail of the swipe that reached "Discover" scrolls straight past the section */
    let lastWheel = 0, busyUntil = 0, relT = null, busy = false, gestureY = 0;
    const release = () => {
      const now = performance.now(), wait = Math.max(busyUntil - now, lastWheel + 220 - now);
      if (wait > 0) { relT = setTimeout(release, wait); return; }
      relT = null; busy = false; stepBusy = false;
    };
    const lock = (ms = ph() === n() - 1 || ph() === 0 ? 1500 : 650) => {
      busy = true; stepBusy = true; busyUntil = performance.now() + ms;
      clearTimeout(relT); relT = setTimeout(release, 60);
    };
    const settle = (r) => lock(r === 'park' ? 300 : undefined);
    ac.signal.addEventListener('abort', () => clearTimeout(relT));
    const fresh = swipeWatch();
    on('wheel', (e) => {
      const now = performance.now(), isNew = fresh(e); if (isNew) gestureY = scrollY; lastWheel = now; // a new gesture starts here
      if (busy) {
        // a new swipe after the step has played ends the lock now instead of waiting for a quiet wheel
        if (isNew && now >= busyUntil) { clearTimeout(relT); relT = null; busy = false; stepBusy = false; }
        else { const s = sec(), ly = lockY(s); if (Math.abs(scrollY - ly) < 4) e.preventDefault(); return; }
      }
      if (Math.abs(e.deltaY) < 4) return;
      const r = tryStep(Math.sign(e.deltaY), e, Math.abs(gestureY - lockY(sec())) > 160);
      if (r) { e.preventDefault(); settle(r); }
    }, { passive: false });
    let ty = null;
    on('touchstart', (e) => { ty = e.touches[0].clientY; }, { passive: true });
    on('touchmove', (e) => { if (ty == null) return; const dy = ty - e.touches[0].clientY; if (busy) { e.preventDefault(); return; } if (Math.abs(dy) > 24 && tryStep(Math.sign(dy), e)) { e.preventDefault(); lock(); ty = null; } }, { passive: false });
    on('keydown', (e) => { if (busy || (e.target && e.target.closest && e.target.closest('.stepprog'))) return; const dir = keyDir(e); if (dir && tryStep(dir, e)) { e.preventDefault(); lock(); } });
    /* progress segments: once the walk-through has been played to the end, segment k jumps straight to step k;
       clicking the current step's segment steps back one, so the first segment also leads back to the bare "Brush" */
    sec().addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('.stepprog button'); if (!b || !pinState[id].done) return;
      const k = [...b.parentNode.children].indexOf(b) + 1;
      renderPhase(id, k === ph() ? k - 1 : k);
    }, opt());
    /* while locked: hold the lock point against the uncancellable rest of the gesture.
       gate, first visit: a fling, momentum tail or scrollbar nudge that carries past the lock point is pulled back to it
       and parks there. Big jumps (header links) are left alone. */
    let prevY = scrollY;
    on('scroll', () => {
      const y = scrollY, py = prevY; prevY = y;
      if (innerWidth <= 900) return; const ly = lockY(sec());
      if (busy) { const d = Math.abs(y - ly); if (d > 1 && d < innerHeight) { scrollTo({ top: ly, behavior: 'instant' }); prevY = ly; } return; }
      if (!forced()) return;
      if (py <= ly + 40 && py >= ly - innerHeight && y > ly + 40 && y < ly + innerHeight) { scrollTo({ top: ly, behavior: 'instant' }); prevY = ly; lock(300); }
    }, { passive: true });
  }

  /* ── concept page: chart → pixels takes TURN_TICKS wheel ticks, the pills then drop after DROP_TICKS more,
        next tick scrolls on. A tick is one gesture: trackpad momentum counts once (wheel must go quiet first).
        Trackpads don't tick: a swipe is a stream of small deltas, so there the page turns once the swipe has covered
        PAD_TURN px (PAD_DROP for the pills, PAD_BACK to go back) — a nudge just reads, a real swipe turns. ── */
  let conceptBusy = false, conceptHold = (ms) => {};
  function wireConcept() {
    const TURN_TICKS = 2, DROP_TICKS = 2;
    const PAD_TURN = 240, PAD_DROP = 200, PAD_BACK = 120;
    const id = 'concepts', sec = () => document.getElementById(id), T = () => sec().offsetTop - 62; let timers = [];
    const S = () => pinState[id], last = () => S().steps[0].n - 1;
    let ticks = 0, tickAt = 0;
    const play = (seq) => {
      timers.forEach(clearTimeout); timers = []; S().playing = true;
      seq.forEach((ph, k) => timers.push(later(() => { renderPhase(id, Math.min(ph, last())); if (k === seq.length - 1) S().playing = false; }, k * 520)));
    };
    const tryStep = (dir) => {
      if (innerWidth <= 900) return false; const y = scrollY, t = T(), ph = Math.max(0, S().phase);
      if (Math.abs(y - t) > 40) return false;
      if (dir > 0 && ph < last() && !S().playing) {
        scrollTo({ top: t, behavior: 'instant' });
        const now = performance.now(); if (now - tickAt > 4000) ticks = 0; tickAt = now; ticks++;
        if (ph < 2 && ticks >= TURN_TICKS) { ticks = 0; play([1, 2]); return 1100; }
        if (ph === 2 && ticks >= DROP_TICKS) { ticks = 0; play([3]); return 700; }
        return 250;
      }
      if (dir < 0 && ph > 0) { ticks = 0; scrollTo({ top: t, behavior: 'instant' }); play([0]); return 1100; }
      return false;
    };
    /* trackpad: hold the page while the swipe adds up; true = swallow the event, a number = turned, lock for ms */
    let pad = 0, padAt = 0;
    const trySwipe = (dy) => {
      if (innerWidth <= 900) return false; const y = scrollY, t = T(), ph = Math.max(0, S().phase), dir = Math.sign(dy);
      if (Math.abs(y - t) > 40) return false;
      if (dir > 0 ? (ph >= last() || S().playing) : ph === 0) return false;
      const now = performance.now(); if (now - padAt > 1000 || Math.sign(pad) !== dir) pad = 0; padAt = now; pad += dy;
      scrollTo({ top: t, behavior: 'instant' });
      if (dir < 0) { if (pad > -PAD_BACK) return true; pad = 0; ticks = 0; play([0]); return 1100; }
      if (ph < 2 && pad >= PAD_TURN) { pad = 0; play([1, 2]); return 1100; }
      if (ph === 2 && pad >= PAD_DROP) { pad = 0; play([3]); return 700; }
      return true;
    };
    let lastWheel = 0, busyUntil = 0, relT = null;
    const release = () => {
      const now = performance.now(), wait = Math.max(busyUntil - now, lastWheel + 220 - now);
      if (wait > 0) { relT = setTimeout(release, wait); return; }
      relT = null; conceptBusy = false;
    };
    const lock = (ms) => { conceptBusy = true; busyUntil = performance.now() + ms; clearTimeout(relT); relT = setTimeout(release, 60); };
    conceptHold = lock;
    /* while locked, hold T against a gesture whose rest can't be cancelled (see wireStepper) */
    on('scroll', () => { if (!conceptBusy || innerWidth <= 900) return; const t = T(), d = Math.abs(scrollY - t); if (d > 1 && d < innerHeight) scrollTo({ top: t, behavior: 'instant' }); }, { passive: true });
    ac.signal.addEventListener('abort', () => clearTimeout(relT));
    const fresh = swipeWatch();
    on('wheel', (e) => {
      const now = performance.now(), isNew = fresh(e); lastWheel = now;
      if (conceptBusy) {
        if (isNew && now >= busyUntil) { clearTimeout(relT); relT = null; conceptBusy = false; } // see wireStepper
        else { if (Math.abs(scrollY - T()) < 4) e.preventDefault(); return; }
      }
      // a gesture's first event decides whether Chrome lets the rest be cancelled, so claim even an empty one at T
      if (isTrackpad(e)) { if (!e.deltaY) { if (!e.ctrlKey && innerWidth > 900 && Math.abs(scrollY - T()) <= 40) e.preventDefault(); return; } const ms = trySwipe(e.deltaY); if (ms) { e.preventDefault(); if (ms !== true) lock(ms); } return; }
      if (Math.abs(e.deltaY) < 4) return; const ms = tryStep(Math.sign(e.deltaY)); if (ms) { e.preventDefault(); lock(ms); }
    }, { passive: false });
    let ty = null;
    on('touchstart', (e) => { ty = e.touches[0].clientY; }, { passive: true });
    on('touchmove', (e) => { if (ty == null) return; const dy = ty - e.touches[0].clientY; if (conceptBusy) { e.preventDefault(); return; } if (Math.abs(dy) > 24) { const ms = tryStep(Math.sign(dy)); if (ms) { e.preventDefault(); lock(ms); ty = null; } } }, { passive: false });
    on('keydown', (e) => { if (conceptBusy) return; const dir = keyDir(e); const ms = dir && tryStep(dir); if (ms) { e.preventDefault(); lock(ms); } });
  }

  /* ── equal breathing room: pixels → What-if  ==  What-if → LLM-Native Figure ── */
  function evenGaps() {
    const R = (e) => e.getBoundingClientRect();
    const stk = document.querySelector('#concepts .sticky'), fig = document.querySelector('#concepts .fig.on svg');
    const w = document.getElementById('whatif'), n = document.getElementById('native');
    if (!w || !n) return;
    if (!stk || !fig || innerWidth <= 900) { n.style.paddingTop = ''; return; }
    n.style.paddingTop = '';
    const gapA = (R(stk).bottom - R(fig).bottom) + (R(w.querySelector('.w')).top - R(w).top);
    const ncont = Math.min(R(n.querySelector('svg')).top, R(n.querySelector('h2')).top); const pt = parseFloat(getComputedStyle(n).paddingTop);
    const gapB = (R(w).bottom - R(w.querySelector('.tail')).bottom) + (ncont - R(n).top);
    n.style.paddingTop = Math.max(24, pt + gapA - gapB) + 'px';
  }

  /* ── hero ⇄ first concept page: page-turn snap, no in-between state ── */
  function wireHero() {
    const hero = document.getElementById('top'), sec = document.getElementById('concepts'); let busy = false;
    const target = () => { const stk = sec.querySelector('.sticky'); const top = parseFloat(getComputedStyle(stk).top) || 62; return sec.offsetTop - top; };
    const go = (y) => {
      busy = true; scrollTo({ top: y, behavior: 'instant' });
      if (y > 0) conceptHold(450); // the swipe that turned the page doesn't count as a concept tick
      if (y === 0 && pinState.concepts && pinState.concepts.phase > 0) renderPhase('concepts', 0);
      const el = y === 0 ? hero : sec.querySelector('.cols'); el.classList.remove('pagein'); void el.offsetWidth; el.classList.add('pagein');
      later(() => { busy = false; }, 450);
    };
    const decide = (dir) => {
      if (innerWidth <= 900) return false; const T = target(), y = scrollY;
      if (dir > 0 && y < T - 4) { go(T); return true; }
      if (dir < 0 && y > 0 && y <= T + 4) { go(0); return true; }
      return false;
    };
    on('wheel', (e) => { if (e.defaultPrevented || conceptBusy) return; if (busy) { if (scrollY < target() + 8) e.preventDefault(); return; }
      // a trackpad swipe opens with tiny deltas: claim them, or Chrome makes the rest of the swipe (momentum too) uncancellable
      if (Math.abs(e.deltaY) < 4) { if (!e.ctrlKey && e.deltaY >= 0 && innerWidth > 900 && scrollY < target() - 4) e.preventDefault(); return; }
      if (decide(Math.sign(e.deltaY))) e.preventDefault(); }, { passive: false });
    let ty = null;
    on('touchstart', (e) => { ty = e.touches[0].clientY; }, { passive: true });
    on('touchmove', (e) => { if (ty == null || e.defaultPrevented) return; const dy = ty - e.touches[0].clientY; if (busy) { e.preventDefault(); return; } if (Math.abs(dy) > 24) { if (decide(Math.sign(dy))) { e.preventDefault(); ty = null; } } }, { passive: false });
    on('keydown', (e) => { if (busy) return; const dir = keyDir(e); if (e.defaultPrevented) return; if (dir && decide(dir)) e.preventDefault(); });
  }

  /* ── replay static-section animations when they scroll into view ── */
  function wireReplay() {
    const io2 = new IntersectionObserver((es) => {
      es.forEach((en) => {
        if (!en.isIntersecting) return; const sec = en.target; const sv = sec.querySelector('svg');
        if (sec.id === 'whatif') document.getElementById('whatifbg').innerHTML = coverSVG.river();
        if (sec.id === 'native' && sv) sv.innerHTML = STEPS[2].svg();
        if (sec.id === 'versions' && sv) sv.innerHTML = STEPS[4].svg(1);
        sec.querySelectorAll('.w,.tail,.fhead,.fcap').forEach(replay);
      });
    }, { threshold: 0.35 });
    ['whatif', 'native', 'versions'].forEach((id) => { const el = document.getElementById(id); if (el) io2.observe(el); });
    observers.push(io2);
  }

  /* ── narrow screens only: no wheel-stepping there, so each stepped section plays its phases by itself when it
        scrolls into view (and again on every re-entry). Desktop never reaches this. ── */
  function wireMobile() {
    const SEQ = { concepts: [[0, 0], [1, 1600], [2, 2120], [3, 3600]] }; // chart → pixels like the desktop turn, then the pills drop
    const GAP = 2000;
    const timers = {};
    const stop = (id) => { (timers[id] || []).forEach(clearTimeout); timers[id] = []; };
    ac.signal.addEventListener('abort', () => Object.keys(timers).forEach(stop));
    /* gate (every stepped section): until its walk-through has played to the end once, the page is held on the section.
       Touch, wheel and key scrolling are swallowed and momentum drift is pulled back; a big jump (header link) releases. */
    let hold = null; // { id, y, settleAt }
    const played = new Set(); // sections whose walk-through has been watched to the end on this screen
    const holdY = (sec) => {
      const col = sec.querySelector('.stagecol') || sec, avail = innerHeight - 62;
      if (sec.offsetHeight <= avail) return Math.round(sec.offsetTop + sec.offsetHeight / 2 - (innerHeight + 62) / 2);
      const r = col.getBoundingClientRect(); // too tall: centre the chart column instead
      return Math.round(r.top + scrollY + r.height / 2 - (innerHeight + 62) / 2);
    };
    const release = () => { hold = null; };
    const startHold = (id, ms) => {
      const y = Math.max(0, holdY(document.getElementById(id)));
      hold = { id, y, settleAt: performance.now() + 600 };
      scrollTo({ top: y, behavior: 'smooth' });
      timers[id].push(later(() => { played.add(id); release(); }, ms));
    };
    const held = () => hold && innerWidth <= 900;
    // an in-page link (nav menu) scrolls straight through the gated section: don't catch it on the way
    let jumpUntil = 0;
    on('click', (e) => { const a = e.target && e.target.closest && e.target.closest('a[href^="#"]'); if (a) { jumpUntil = performance.now() + 1500; release(); } }, { capture: true });
    on('touchmove', (e) => { if (held()) e.preventDefault(); }, { passive: false });
    on('wheel', (e) => { if (held()) e.preventDefault(); }, { passive: false });
    on('keydown', (e) => { if (held() && keyDir(e)) e.preventDefault(); });
    on('scroll', () => {
      if (!held() || performance.now() < hold.settleAt) return;
      const d = Math.abs(scrollY - hold.y);
      if (d > innerHeight) { stop(hold.id); release(); return; }
      if (d > 2) scrollTo({ top: hold.y, behavior: 'instant' });
    }, { passive: true });
    const play = (id) => {
      const S = pinState[id]; if (!S) return; stop(id);
      const n = S.steps[0].n, seq = SEQ[id] || Array.from({ length: n }, (_, k) => [k, k * GAP]);
      // not on first paint: a section already in view at load just plays, the page isn't yanked to it
      const gate = !played.has(id) && scrollY > 0 && performance.now() > jumpUntil;
      S.phase = -1; // force a fresh render so the entry animations replay
      seq.forEach(([ph, t]) => timers[id].push(later(() => renderPhase(id, ph), t)));
      if (gate) startHold(id, seq[seq.length - 1][1] + 1400); // the last step's animation plays out before scrolling is let go
    };
    const io = new IntersectionObserver((es) => {
      if (innerWidth > 900) return;
      es.forEach((en) => { const id = en.target.id; if (en.isIntersecting) { if (!(hold && hold.id === id)) play(id); } else if (!(hold && hold.id === id)) stop(id); });
    }, { threshold: 0.3 });
    PINS.forEach((pn) => { const el = document.getElementById(pn.sec); if (el) io.observe(el); });
    observers.push(io);
  }

  /* ── "keep scrolling" cue: the wheel-stepped sections (#concepts, #bad, #bidir) swallow scroll ticks to play their
        steps, which reads as the page being stuck — show a bouncing arrow while one of them holds the viewport centre ── */
  function wireCue() {
    const cue = document.querySelector('.scrollcue'); if (!cue) return;
    const secs = PINS.map((pn) => document.getElementById(pn.sec)).filter(Boolean);
    const update = () => {
      const mid = (innerHeight + 62) / 2;
      cue.classList.toggle('on', secs.some((s) => { const r = s.getBoundingClientRect(); return r.top < mid && r.bottom > mid; }));
    };
    on('scroll', update, { passive: true });
    on('resize', update);
    update();
  }

  // listener order matches the design file: bad (+ bidir) → concept → hero (the hero snap checks e.defaultPrevented)
  on('resize', sizePins);
  on('scroll', onScroll, { passive: true });
  on('resize', onScroll);
  wireStepper('bad', true);
  wireStepper('bidir');
  wireConcept();
  on('resize', evenGaps);
  [300, 1200, 2500].forEach((t) => later(evenGaps, t));
  on('load', () => later(evenGaps, 200));
  (document.fonts && document.fonts.ready || Promise.resolve()).then(() => { if (!ac.signal.aborted) later(evenGaps, 100); });
  wireHero();
  wireReplay();

  buildRot();
  wireMobile();
  wireCue();
  onScroll();

  return () => {
    ac.abort();
    timeouts.forEach(clearTimeout);
    observers.forEach((o) => o.disconnect());
  };
}
